export const SET_EMPLOYEE_DETAILS = "SET_EMPLOYEE_DETAILS";
export const UPDATE_EMPLOYEE_ADDRESS = "UPDATE_EMPLOYEE_ADDRESS";
interface Employee {
  id: string;
  name: string;
}

export interface Action {
  type: string;
  state: any;
}

export const setEmployeeDetails = (data: Employee): Action => ({
  type: SET_EMPLOYEE_DETAILS,
  state: data,
});

export const updateEmployeeAddress = (data: any): Action => ({
  type: UPDATE_EMPLOYEE_ADDRESS,
  state: data,
});
